import { Injectable, Signal } from '@angular/core';
import { IClassifyData, IClassifyModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { ClassifyActions, ClassifySelectors, IClassifyState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class ClassifyStore extends StateAccessService<IClassifyState> {
  readonly state$: Observable<IClassifyState>;

  readonly data$$: Signal<IClassifyData>;
  readonly model$$: Signal<IClassifyModel>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(ClassifySelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(ClassifySelectors.data);
  }

  dispatchClassifySubmit() {
    this.stateFacade.dispatch(ClassifyActions.submit());
  }

  dispatchClassifySubmitSuccess({ model, data }: { model: IClassifyModel; data: IClassifyData }) {
    this.stateFacade.dispatch(ClassifyActions.submitSuccess({ model, data }));
  }
}
